import React from 'react';
import styles from './Contact.module.css';

const Contact = () => {
  return (
    <section id="contact" className={styles.contact}>
      <h2>Get In Touch</h2>
      <p>Feel free to drop me an email, or find me on LinkedIn or GitHub!</p>
      <div className={styles.links}>
        <a href="mailto:justinhynes@gmail.com" className={styles.link}>Email</a>
        <a href="https://www.linkedin.com/in/hynesjustin" target="_blank" rel="noopener noreferrer" className={styles.link}>LinkedIn</a>
        <a href="https://github.com/justinhynes" target="_blank" rel="noopener noreferrer" className={styles.link}>GitHub</a>
      </div>
    </section>
  );
};

export default Contact;
